var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ad-container"},[_c('Adsense',{attrs:{"data-ad-client":"ca-pub-2457058330866327","data-ad-slot":"5611925611","data-ad-format":"auto","data-full-width-responsive":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }